(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agreements-workflow', {
                parent: 'app',
                url: '/agreements/workflow/:id',
                data: {
                    authorities: ['ROLE_PATIENT'],
                    pageTitle: 'ipmApp.agreements.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/agreements-workflow/agreements-workflow.html',
                        controller: 'AgreementsWorkflowController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('agreements');
                        return $translate.refresh();
                    }],
                },
                params: {
                    id: null
                }
            });

    }

})();
